import { useEffect } from 'react';

import { AsyncThunk } from '@reduxjs/toolkit';

import { useAppDispatch } from '../../../store/hooks';

export const useGetTableResults = <THeaderAndPaginationFilters, TResults>(
  filters: Partial<THeaderAndPaginationFilters>,
  dispatchFn: AsyncThunk<
    TResults,
    Partial<THeaderAndPaginationFilters> | undefined,
    Record<string, unknown>
  >,
  nameFilter?: string,
  activeMandantId?: number | null
): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (activeMandantId !== null) {
      dispatch(dispatchFn(filters));
    }
  }, [nameFilter, activeMandantId]);
};
